module.exports = __webpack_public_path__ + "static/media/GTBSLong1w522@2x.8461da21.webp";